import { useState } from 'react';
import type { ImportShopResult } from '@reims-local/types';
import { adminApi } from '../lib/api';

const CSV_TEMPLATE = `nom,adresse,email,telephone,type,categorie,partenaire,notes
Panino Divino,"36 rue du Jard 51100 Reims",contact@paninodivino.eu,0749395631,SHOP_FOOD,Épicerie fine / Traiteur,vitrines_reims,Flux 2 prioritaire
Bistrot Crêperie des Sacres,"97 rue Clovis 51100 Reims",reservation@bistrotcreperiesacres.com,0326074875,RESTAURANT,Crêperie,vitrines_reims,Flux 3 pilote`;

export function ImportCSV() {
  const [csv, setCsv] = useState(CSV_TEMPLATE);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<ImportShopResult | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setResult(null);
    try {
      const res = await adminApi.importShops(csv);
      setResult(res.data);
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setLoading(false);
    }
  }

  function onFile(e: React.ChangeEvent<HTMLInputElement>) {
    const f = e.target.files?.[0];
    if (!f) return;
    const reader = new FileReader();
    reader.onload = () => setCsv(String(reader.result ?? ''));
    reader.readAsText(f);
  }

  return (
    <>
      <h2>Import CSV — Boutiques</h2>
      <p className="muted">
        Colonnes requises : <code>nom, email, type</code>. Optionnelles :{' '}
        <code>adresse, telephone, categorie, partenaire, notes</code>. Limite 500 lignes.
      </p>

      <form className="card" onSubmit={submit}>
        {error && <div className="alert alert-error">{error}</div>}

        <div className="form-row">
          <label>Fichier CSV (ou collez directement ci-dessous)</label>
          <input type="file" accept=".csv,text/csv" onChange={onFile} />
        </div>

        <div className="form-row">
          <label>Contenu CSV</label>
          <textarea
            rows={12}
            value={csv}
            onChange={(e) => setCsv(e.target.value)}
            style={{ fontFamily: 'ui-monospace, monospace', fontSize: 13 }}
          />
        </div>

        <button className="primary" type="submit" disabled={loading}>
          {loading ? 'Import…' : 'Lancer l’import'}
        </button>
      </form>

      {result && (
        <div className="card" style={{ marginTop: 24 }}>
          <h3 style={{ marginTop: 0 }}>Résumé</h3>
          <p>
            <strong>{result.created}</strong> créées, <strong>{result.skipped}</strong> ignorées
            (doublons), <strong>{result.errors.length}</strong> erreurs sur {result.total} lignes.
          </p>
          {result.errors.length > 0 && (
            <>
              <h4>Erreurs</h4>
              <table>
                <thead>
                  <tr>
                    <th>Ligne</th>
                    <th>Raison</th>
                  </tr>
                </thead>
                <tbody>
                  {result.errors.map((e, i) => (
                    <tr key={i}>
                      <td>{e.line}</td>
                      <td>{e.reason}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
        </div>
      )}
    </>
  );
}
